import React from 'react';
import { StyledRadioInput } from '../styled';
import { SwatchProps } from '../types';
import {
  StyledTextSwatch,
  TextSwatchContainer,
  OptionLabel,
  SoldOutLabel,
  SoldOutContainer,
  SoldOutIcon,
  PriceLabel
} from './styled';

export const TextSwatch = ({
  id,
  name,
  title = '',
  label,
  checked,
  disabled,
  price,
  discountedPrice,
  onClick,
  onChange,
  onMouseOver,
  onMouseOut,
  ref
}: SwatchProps): JSX.Element => {
  const strikethroughPrice = discountedPrice && `+${formatPrice(price)}`;
  const priceLabel = (price || discountedPrice)
    ? `+${formatPrice(discountedPrice ?? price)}`
    : undefined;

    return (
    <TextSwatchContainer>
      <StyledTextSwatch
        id={`option-value-label-${title}`}
        className={`${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
        htmlFor={`option-value-${id}`}
        onClick={disabled ? undefined : onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        aria-checked={checked}
      >
        <StyledRadioInput
          id={`option-value-${id}`}
          type="radio"
          name={name}
          value={id}
          checked={checked}
          disabled={false}
          onChange={disabled ? undefined : onChange}
          onFocus={disabled ? undefined : onClick}
          ref={ref}
        />
        <OptionLabel disabled={disabled}>{label}</OptionLabel>
        {priceLabel && <PriceLabel strikethrough={!!discountedPrice} disabled={disabled}>
          {priceLabel}
          {strikethroughPrice && <span className="strikethrough-price">{strikethroughPrice}</span>}
        </PriceLabel>}
        {disabled && (
          <SoldOutContainer>
            <SoldOutIcon icon="close" />
            <SoldOutLabel>Sold Out</SoldOutLabel>
          </SoldOutContainer>
        )}
      </StyledTextSwatch>
    </TextSwatchContainer>
  );
};

export default TextSwatch;

const formatPrice = (amount: number | string): string => {
  const locale = 'en-US';
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  };
  const formatter = new Intl.NumberFormat(locale, options);
  return formatter.format(Number(amount)).replace(/\.0+$/, '');
};